jQuery(document).ready(function($) {

	/*
	 *	mmenu mobile nav
	 */
	$('#mmenu').on( 'closed', function() {
		$('#mmenu .mm-panel').first().trigger( 'open.mm' );
	});

	/*
	*	Search button
	*/
	$('.icon-search').on('click', function(){
		$('.mainsearch').toggle();
		$('#s').focus();
	});
	$('.icon-close-x').on('click', function(){
		$('.mainsearch').toggle();
	});

	/*
	 *	Nav menu
	 */
	//Main menu hover function
	$('#menu-location-primary > .menu > li').on('mouseenter', function(){
		$(this).children('.sub-menu').show();
	});
	$('#menu-location-primary > .menu > li').on('mouseleave', function(){
		$(this).children('.sub-menu').hide();
	});

	//touch device
	if (window.ontouchstart !== undefined){
		$('#menu-location-primary > .menu > li').on('click', function(){
			if($(this).children('.sub-menu').hasClass('active')) {
				$(this).children('.sub-menu').hide();
				$(this).children('.sub-menu').removeClass('active');

			}
			else{
				$(this).children('.sub-menu').show();
				$(this).children('.sub-menu').addClass('active');
			}
		});
	}

	/*
	 *	Side menu
	 */
	$('.menutoggle').on('click', function(){
		$('.sidebar .bg').slideToggle('1000');
		$('.menutoggle i').toggleClass('icon-arrow-down icon-arrow-up');
	});

	var width = $(window).width();
	var height = $(window).height();
	//$( window ).resize(function() {
	if($(window).width() !== width && $(window).height() !== height){
		$('.sidebar .bg').show();
		$('.sidebar .menutoggle').hide();
	}

	/**
	 * Set the HTTP Referrer & Campaign Variables
	 */

	// If not already set, set a session cookie for HTTP Referrer
	if ( ! docCookies.hasItem( 'http_referrer' ) ) {
		docCookies.setItem( 'http_referrer', document.referrer, null, '/', window.location.hostname );
	}

	// If not already set, set a session cookie for the query string
	if ( ! docCookies.hasItem( 'query_string' ) ) {
		docCookies.setItem( 'query_string', window.location.search, null, '/', window.location.hostname );
	}

	/**
	 * Gravity Forms tracking
	 */
	if ( 1 <= $('.gform_body').length ) {
		var referrer = '';

		// Get the referrer – the cookie value is null when traffic was direct
		if ( docCookies.getItem( 'http_referrer' ) == null ) {
			referrer = 'Direct';
		} else {
			referrer = docCookies.getItem( 'http_referrer' );
		}

		// Add params to fields.
		$('.gf-referrer-field input').val( referrer );
		$('.gf-query-field input').val( docCookies.getItem( 'query_string' ) );
	}

	/**
	 * Open trust popups.
	 */
	$('.popup-open').on('click', function(e) {
		e.preventDefault();
		var parent = $(this).closest('.statitem');
		var heading = parent.find('.statitem__heading');
		var datetime = parent.find('.statitem__date');
		var content = parent.find('.statitem__content');
		var quote_name = parent.find('.statitem__quote .quote-name');
		var quote_content = parent.find('.statitem__quote .quote-content');
		if ( parent.hasClass('statitem--red') ) {
			$('.trusts__popup .popup-right').addClass('statitem--red');
		} else {
			$('.trusts__popup .popup-right').removeClass('statitem--red');
		}
		$('.trusts__popup .heading').html( heading.attr('data-heading') );
		$('.trusts__popup .datetime').html( datetime.html() );
		$('.trusts__popup .popup-left').html( content.html() );
		$('.trusts__popup .popup-right').html( parent.html() );
		$('.trusts__popup .popup-quote .quote').html( quote_content.html() );
		$('.trusts__popup .popup-quote .person').html( quote_name.html() );
		$('.trusts__popup').fadeIn();
		$([document.documentElement, document.body]).animate({
			scrollTop: $('.trusts__popup').offset().top - 125
		}, 2000);
	});

	/**
	 * Close trust popups.
	 */
	$('.popup-close').on('click', function(e) {
		e.preventDefault();
		$(this).closest('.trusts__popup').fadeOut();
	});

	/**
	 * Trust read more GTM trigger.
	 */
	$('.statitem__more a').on('click', function(e) {
		var trustStat = $(this).attr('data-trust-stat');
		if ( '' != trustStat ) {
			dataLayer.push({ 'event': 'Trust Popup: ' + trustStat });
		}
	});

});
